module.exports = __webpack_public_path__ + "img/FF_Info_Game_3.78697b4f.png";